<template>
	<v-dialog
		v-model="showDialog"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		@click:outside="closeDialog"
	>
		<!-- TODO デザイン -->
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar :color="$vuetify.theme.themes.dark.gray" dense flat>
				<v-spacer></v-spacer>
				<v-btn icon dark color="white" @click="closeDialog">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="box">
				<Moveable
					class="moveable"
					:target="target"
					:resizable="resizable"
					:draggable="draggable"
					:moveable="moveable"
					@drag="handleDrag"
					@resize="handleResize"
				>
					<div class="target">
						<v-img v-if="typeImage(attached_file)" :src="attached_file.url" contain />
					</div>
				</Moveable>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
import Moveable from "vue-moveable"

export default {
	components: {
		Moveable,
	},
	props: {
		text: Boolean,
		requiredDialogBtn: {
			type: Boolean,
			required: false,
			default: false,
		},
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		attached_file: {
			type: Object,
			required: false,
		},
	},
	data() {
		return {
			moveable: {
				draggable: true,
				throttleDrag: 0,
				resizable: true,
				keepRatio: true,
				throttleResize: 1,
				scalable: false,
				throttleScale: 0,
				rotatable: false,
				throttleRotate: 0,
				pinchable: false,
				origin: false,
				target: null,
			},
			resizable: true,
			draggable: true,
			target: null,
			page: 0,
			currentPage: 0,
			pageCount: 0,
		}
	},
	mounted() {},
	methods: {
		handleDrag({ target, transform }) {
			target.style.transform = transform
		},
		handleResize({ target, width, height, delta }) {
			delta[0] && (target.style.width = `${width}px`)
			delta[1] && (target.style.height = `${height}px`)
		},
		closeDialog() {
			this.showDialog = false
			this.resizable = false
			this.draggable = false
			// NOTE 青枠が残るため非表示に
			const box = document.getElementsByClassName("moveable-control-box")
			if (box.length > 0) {
				box[0].style.opacity = 0
			}
		},
		typeImage(file) {
			return file.file_content_type == "image/jpeg" || file.file_content_type == "image/png"
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		showDialog(newVal) {
			if (newVal) {
				this.resizable = true
				this.draggable = true
				const box = document.getElementsByClassName("moveable-control-box")
				if (box.length > 0) {
					box[0].style.opacity = 1
				}
				this.$nextTick(() => {
					setTimeout(() => {
						const target = document.getElementsByClassName("target")
						this.target = target[0]
					}, 500)
				})
			}
		},
	},
}
</script>

<style scoped lang="scss">
@import "../../stylesheet/global.scss";
.box {
	background-color: $darkgrey;
	padding: 0 2.35rem 2.35rem 2.35rem;
}
</style>
